import { render, staticRenderFns } from "./GlobalFooter.vue?vue&type=template&id=4a109b64&scoped=true&"
import script from "./GlobalFooter.vue?vue&type=script&lang=ts&"
export * from "./GlobalFooter.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalFooter.vue?vue&type=style&index=0&id=4a109b64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a109b64",
  null
  
)

export default component.exports